import { createFeatureProtector } from '@dreryk/egabinet-security-frontend';

export const protectFeature = createFeatureProtector({
   adamedExpert: 'egab.adamedExpert',
   adjustingSettlementOfAllVisits: 'egab.adjustingSettlementOfAllVisits',
   adjustingSettlementOfYourOwnVisits: 'egab.adjustingSettlementOfYourOwnVisits',
   bookingVideoConsultations: 'egab.bookingVideoConsultations',
   conductingGroupSessions: 'egab.conductingGroupSessions',
   conductingPreInterview: 'egab.conductingPreInterview',
   conductingYourOwnVisitPreInterview: 'egab.conductingYourOwnVisitPreInterview',
   creatingAppointments: 'egab.creatingAppointments',
   creatingGynecologicalInterview: 'egab.creatingGynecologicalInterview',
   creatingInvoices: 'egab.creatingInvoices',
   creatingMedicalDocuments: 'egab.creatingMedicalDocuments',
   creatingPatientMedicalInformation: 'egab.creatingPatientMedicalInformation',
   creatingPatientNotes: 'egab.creatingPatientNotes',
   creatingPatients: 'egab.creatingPatients',
   creatingStatistics: 'egab.creatingStatistics',
   creatingVisits: 'egab.creatingVisits',
   deprecated: 'egab.deprecated',
   // This is expected
   // eslint-disable-next-line @dreryk/check-experimental-to-do
   experimental: 'egab.experimental',
   aiExperimental: 'egab.aiExperimental',
   aiAssistant: 'egab.aiAssistant',
   extendedMedicineDatabase: 'egab.extendedMedicineDatabase',
   issuingDischargeSummary: 'egab.issuingDischargeSummary',
   issuingMedicalCertificates: 'egab.issuingMedicalCertificates',
   issuingMedicalDeviceOrders: 'egab.issuingMedicalDeviceOrders',
   issuingMedicalLeaves: 'egab.issuingMedicalLeaves',
   issuingPaperDocumentsFromTemplate: 'egab.issuingPaperDocumentsFromTemplate',
   issuingPrescriptions: 'egab.issuingPrescriptions',
   issuingReferrals: 'egab.issuingReferrals',
   managingClients: 'egab.managingClients',
   managingDocplannerIntegration: 'egab.managingDocplannerIntegration',
   managingDocplannerSlots: 'egab.managingDocplannerSlots',
   managingGroupSessions: 'egab.managingGroupSessions',
   managingInvoices: 'egab.managingInvoices',
   managingOnlinePaymentsConfiguration: 'egab.managingOnlinePaymentsConfiguration',
   managingMedicalAttachment: 'egab.managingMedicalAttachment',
   managingPatientPortal: 'egab.managingPatientPortal',
   managingPrivateMedicalServices: 'egab.managingPrivateMedicalServices',
   managingVideoConsultations: 'egab.managingVideoConsultations',
   managingVisitSettlements: 'egab.managingVisitSettlements',
   medicalDashboard: 'egab.medicalDashboard',
   performingPrivateMedicalServices: 'egab.performingPrivateMedicalServices',
   performingVideoConsultations: 'egab.performingVideoConsultations',
   pharmindexIntegration: 'medicines.pharmindex.medicineIntegration',
   privateMedicalServicesReadOnly: 'egab.privateMedicalServicesReadOnly',
   refundingOnlinePayments: 'egab.refundingOnlinePayments',
   searchingAllAppointments: 'egab.searchingAllAppointments',
   searchingAllAvailabilities: 'egab.searchingAllAvailabilities',
   searchingAllPractitioners: 'egab.searchingAllPractitioners',
   searchingAllPractitionersDetails: 'egab.searchingAllPractitionersDetails',
   searchingAppointments: 'egab.searchingAppointments',
   searchingFirstAvailableSlotInCalendar: 'egab.searchingFirstAvailableSlotInCalendar',
   searchingMedicalData: 'egab.searchingMedicalData',
   searchingPrivateMedicalServices: 'egab.searchingPrivateMedicalServices',
   searchingVisitOperations: 'egab.searchingVisitOperations',
   searchingYourOwnVisits: 'egab.searchingYourOwnVisits',
   sendingDocumentsToPatient: 'egab.sendingDocumentsToPatient',
   settlingMedicalServicesPerformedByAnyPractitioner: 'egab.settlingMedicalServicesPerformedByAnyPractitioner',
   settlingMedicalServicesPerformedByOneself: 'egab.settlingMedicalServicesPerformedByOneself',
   settingPatientPregnancy: 'egab.settingPatientPregnancy',
   updatingAvailability: 'egab.updatingAvailability',
   updatingDoctorPersonalData: 'egab.updatingDoctorPersonalData',
   updatingParamedicPersonalData: 'egab.updatingParamedicPersonalData',
   updatingProviderData: 'egab.updatingProviderData',
   updatingReceptionistPersonalData: 'egab.updatingReceptionistPersonalData',
   usingMedicalRecordNumbers: 'egab.usingMedicalRecordNumbers',
});
